export default [
  {
    title: 'security',
    icon: 'fas fa-shield-alt',
    children: [
      {
        path: '/roles',
        title: 'roleManagement',
        permission: 'view-roles',
        allowedUserType: 'Subscription|Operation'
      },
      {
        path: '/users',
        title: 'userManagement',
        permission: 'view-users',
        allowedUserType: 'Subscription|Operation'
      }
    ]
  },
  {
    title: 'administration',
    icon: 'fas fa-th',
    children: [
      {
        path: '/companies',
        title: 'companyProfile',
        permission: 'view-companies',
        allowedUserType: 'Subscription'
      },
      {
        path: '/branches',
        title: 'branchProfile',
        permission: 'view-branches',
        allowedUserType: 'Subscription'
      },
      { path: '/departments', title: 'Department' },
      { path: '/locations', title: 'Setup Location' },
      { path: '/exchange-rates', title: 'Exchange Rate' },
      { path: '/divisions', title: 'Division' },
      { path: '/customer-profiles', title: 'Customer Profile' },
      { path: '/vendor-profiles', title: 'Vendor Profile' },
      { path: '/card-profiles', title: 'Card Profile' }
    ]
  },
  {
    title: 'Inventory',
    icon: 'far fa-chart-bar',
    children: [
      { path: '/categories', title: 'Category' },
      { path: '/unit-measures', title: 'Unit Measure' },
      { path: '/products', title: 'Product' },
      { path: '/foodcourts', title: 'Food Court' },
      { path: '/counter-profiles', title: 'Counter Profile' },
      { path: '/stock-alert-setting', title: 'Stock Alert' }
    ]
  },
  {
    title: 'Accounting',
    icon: 'fas fa-chart-line',
    children: [{ path: '/chart-of-accounts', title: 'Chart of Account' }]
  },
  {
    title: 'humanResource',
    icon: 'far fa-chart-bar',
    children: [
      {
        title: 'setting',
        children: [
          {
            path: '/signatures',
            title: 'signature',
            permission: 'view-signatures',
            allowedUserType: 'Operation'
          },
          {
            path: '/nationalities',
            title: 'nationality',
            permission: 'view-nationalities',
            allowedUserType: 'Operation'
          },
          {
            path: '/org-chart-levels',
            title: 'organizationalChart',
            permission: 'view-org-chart-levels',
            allowedUserType: 'Operation'
          },
          {
            path: '/org-chart-structures',
            title: 'organizationalStructure',
            permission: 'view-org-chart-structures',
            allowedUserType: 'Operation'
          },
          {
            path: '/job-titles',
            title: 'jobTitle',
            permission: 'view-job-titles',
            allowedUserType: 'Operation'
          },
          {
            path: '/position-levels',
            title: 'positionLevel',
            permission: 'view-position-levels',
            allowedUserType: 'Operation'
          },
          {
            path: '/logical-positions',
            title: 'logicalPosition',
            permission: 'view-logical-positions',
            allowedUserType: 'Operation'
          },
          {
            path: '/holiday-rules',
            title: 'holidayRule',
            permission: 'view-holiday-rules',
            allowedUserType: 'Operation'
          },
          {
            path: '/holidays',
            title: 'holiday',
            permission: 'view-holidays',
            allowedUserType: 'Operation'
          },
          {
            path: '/shift-managements',
            title: 'shiftManagement',
            permission: 'view-shift-managements',
            allowedUserType: 'Operation'
          },
          {
            path: '/leave-rules',
            title: 'leaveRule',
            permission: 'view-leave-rules',
            allowedUserType: 'Operation'
          },
          {
            path: '/leave-sub-items',
            title: 'leaveSubItem',
            permission: 'view-leave-sub-items',
            allowedUserType: 'Operation'
          },
          {
            path: '/attendance-devices',
            title: 'attendanceDevice',
            permission: 'view-attendance-devices',
            allowedUserType: 'Operation'
          }
        ]
      },
      {
        title: 'transaction',
        children: [
          {
            path: '/employee-profiles',
            title: 'employeeProfile',
            permission: 'view-employee-profiles',
            allowedUserType: 'Operation'
          },
          {
            path: '/employee-status-reasons',
            title: 'employeeStatusReason',
            permission: 'view-employee-status-reasons',
            allowedUserType: 'Operation'
          },
          {
            path: '/work-schedules',
            title: 'workSchedule',
            permission: 'view-work-schedules',
            allowedUserType: 'Operation'
          },
          {
            path: '/leave-initial-balances',
            title: 'leaveInitialBalance',
            permission: 'view-leave-initial-balances',
            allowedUserType: 'Operation'
          },
          {
            path: '/leave-records',
            title: 'leaveRecord',
            permission: 'view-leave-records',
            allowedUserType: 'Operation'
          },
          {
            path: '/daily-attendances',
            title: 'dailyAttendance',
            permission: 'view-daily-attendances',
            allowedUserType: 'Operation'
          },
        ]
      },
      {
        title: 'report',
        children: [
          {
            path: 'report-attendance-details',
            title: 'attendanceDetail',
            permission: 'view-report-attendance-details',
            allowedUserType: 'Operation'
          },
          {
            path: 'report-attendance-summaries',
            title: 'attendanceSummary',
            permission: 'view-report-attendance-summaries',
            allowedUserType: 'Operation'
          },
          {
            path: 'report-leave-initial-balances',
            title: 'reportLeaveInitialBalance',
            permission: 'view-report-leave-initial-balances',
            allowedUserType: 'Operation'
          }
        ]
      }
    ]
  },
  {
    title: 'payroll',
    icon: 'fas fa-file-invoice-dollar',
    children: [
      {
        title: 'setting',
        children: [
          {
            path: '/payroll-cycle-dates',
            title: 'cycleDuration',
            permission: 'view-payroll-cycle-dates',
            allowedUserType: 'Operation'
          },
          {
            path: '/pay-user-variables',
            title: 'userFormula',
            permission: 'view-pay-user-variables',
            allowedUserType: 'Operation'
          },
          {
            path: '/basic-salary-formulas',
            title: 'basicSalaryFormula',
            permission: 'view-salary-formulas',
            allowedUserType: 'Operation'
          },
          {
            path: '/pay-basic-salaries',
            title: 'basicSalary',
            permission: 'view-pay-basic-salaries',
            allowedUserType: 'Operation'
          },
          {
            path: '/payroll-cycles',
            title: 'payrollCycle',
            permission: 'view-payroll-cycles',
            allowedUserType: 'Operation'
          },
          {
            title: 'payrollItem',
            children: [
              {
                path: '/pay-item-allowances',
                title: 'itemAllowance',
                permission: 'view-pay-item-allowances',
                allowedUserType: 'Operation'
              },
              {
                path: '/pay-item-deductions',
                title: 'itemDeduction',
                permission: 'view-pay-item-deductions',
                allowedUserType: 'Operation'
              },
              {
                path: '/pay-item-compensates',
                title: 'itemCompensate',
                permission: 'view-pay-item-compensates',
                allowedUserType: 'Operation'
              },
              {
                path: '/pay-item-incentive-bonuses',
                title: 'itemIncentiveBonus',
                permission: 'view-pay-item-incentive-bonuses',
                allowedUserType: 'Operation'
              },
              {
                path: '/pay-item-overtimes',
                title: 'itemOvertime',
                permission: 'view-pay-item-overtimes',
                allowedUserType: 'Operation'
              }
              // temporary no use
              // {
              //   path: '/pay-payroll-item-companies',
              //   title: 'companyItem',
              //   permission: 'view-pay-payroll-item-companies',
              //   allowedUserType: 'Operation'
              // }
            ]
          },
          {
            path: '/pay-overtime-rule-by-shifts',
            title: 'overtimeRuleByShift',
            permission: 'view-pay-overtime-rule-by-shifts',
            allowedUserType: 'Operation'
          },
          {
            path: '/payroll-templates',
            title: 'payrollTemplate',
            permission: 'view-payroll-templates',
            allowedUserType: 'Operation'
          },
          {
            path: '/payslip-templates',
            title: 'payslipTemplate',
            permission: 'view-payslip-templates',
            allowedUserType: 'Operation'
          },
          {
            path: '/tax-ranges',
            title: 'taxRange',
            permission: 'view-tax-ranges',
            allowedUserType: 'Operation'
          }
        ]
      },
      {
        title: 'transaction',
        children: [
          {
            path: '/pay-fixed-allowances',
            title: 'fixedAllowance',
            permission: 'view-pay-fixed-allowances',
            allowedUserType: 'Operation'
          },
          {
            path: '/pay-fixed-incentive-bonuses',
            title: 'fixedIncentiveBonus',
            permission: 'view-pay-fixed-incentive-bonuses',
            allowedUserType: 'Operation'
          },
          {
            path: '/pay-monthly-allowances',
            title: 'monthlyAllowance',
            permission: 'view-pay-monthly-allowances',
            allowedUserType: 'Operation'
          },
          {
            path: '/pay-monthly-deductions',
            title: 'monthlyDeduction',
            permission: 'view-pay-monthly-deductions',
            allowedUserType: 'Operation'
          },
          {
            path: '/pay-monthly-compensates',
            title: 'monthlyCompensate',
            permission: 'view-pay-monthly-compensates',
            allowedUserType: 'Operation'
          },
          {
            path: '/pay-monthly-incentive-bonuses',
            title: 'monthlyIncentiveBonus',
            permission: 'view-pay-monthly-incentive-bonuses',
            allowedUserType: 'Operation'
          },
          {
            path: '/monthly-overtimes',
            title: 'monthlyOvertime',
            permission: 'view-monthly-overtimes',
            allowedUserType: 'Operation'
          },
          {
            path: '/calculate-payrolls',
            title: 'payrollCalculation',
            permission: 'view-payroll-calculations',
            allowedUserType: 'Operation'
          },
          {
            path: '/first-cycle-paids',
            title: 'firstCyclePaid',
            permission: 'view-first-cycle-paids',
            allowedUserType: 'Operation'
          }
        ]
      },
      {
        title: 'report',
        children: [
          {
            path: 'report-payroll-details',
            title: 'payrollDetail',
            permission: 'view-payroll-templates',
            allowedUserType: 'Operation'
          },
          {
            path: 'payslips',
            title: 'payslip',
            permission: 'view-payslips',
            allowedUserType: 'Operation'
          },
          {
            path: 'reconciliations',
            title: 'reconciliation',
            permission: 'view-payroll-templates',
            allowedUserType: 'Operation'
          },
          {
            path: 'report-payroll-nss',
            title: 'reportPayrollNss',
            permission: 'view-report-nss',
            allowedUserType: 'Operation'
          },
          {
            path: 'report-basic-salary-histories',
            title: 'basicSalaryHistory',
            permission: 'view-report-basic-salary-histories',
            allowedUserType: 'Operation'
          }
        ]
      }
    ]
  }
]
